

import { TabStyles } from '@tableau/widgets';

import { divWithStyle } from '../../../style';
import { helpTextDiv, inputHintDiv, textAreaCssClass } from './ExternalContentActionsStyles';

const DATA_QUALITY_TEXT_AREA_HEIGHT = 100;
const DATA_QUALITY_DIALOG_TEST_ID: string = 'data-quality-dialog';
export const DATA_QUALITY_DIALOG_HELP_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-help';
export const DATA_QUALITY_DIALOG_TOGGLE_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-toggle';
export const DATA_QUALITY_DIALOG_SEVERE_TOGGLE_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-severe-toggle';
export const DATA_QUALITY_DIALOG_TYPE_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-type';
export const DATA_QUALITY_DIALOG_MESSAGE_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-message';

const DROPDOWN_WIDTH: number = 200;

export const ContentItemNameDiv = divWithStyle(DATA_QUALITY_DIALOG_TEST_ID, '-content-item-name-text', {
  marginBottom: TabStyles.Spacing.MediumSpace,
  fontSize: TabStyles.Typography.Sizing.Tiny,
  color: TabStyles.Typography.Color.Primary,
});

export const HelpTextDiv = helpTextDiv(DATA_QUALITY_DIALOG_TEST_ID);

export const DropDownPromptDiv = divWithStyle(DATA_QUALITY_DIALOG_TEST_ID, '-dropdown-prompt-text', {
  paddingTop: TabStyles.Spacing.MediumSpace,
});

export const InputHintDiv = inputHintDiv(DATA_QUALITY_DIALOG_TEST_ID);

export const dropDownStyle: React.CSSProperties = {
  width: DROPDOWN_WIDTH,
  marginBottom: TabStyles.Spacing.MediumSpace
};


export const textAreaStyle: React.CSSProperties = {
  height: DATA_QUALITY_TEXT_AREA_HEIGHT,
  resize: 'none',
};

export const markupEditorStyle: React.CSSProperties = {

};

export const textAreaWidgetClass = textAreaCssClass(DATA_QUALITY_DIALOG_MESSAGE_ID);

export const checkboxStyle: React.CSSProperties = {
  marginTop: TabStyles.Spacing.DefaultSpace,
  marginBottom: TabStyles.Spacing.DefaultSpace,
};
